// extracted by mini-css-extract-plugin
export var actions = "_ma-g";
export var benefitCard = "_ma-b";
export var benefitIcon = "_ma-d";
export var benefitLabel = "_ma-f";
export var benefits = "_ma-a";
export var benefitsSection = "_ma-8";
export var bodyText = "_ma-7";
export var closeButton = "_ma-2";
export var content = "_ma-3";
export var eyebrow = "_ma-4";
export var heading = "_ma-5";
export var image = "_ma-i";
export var imagePanel = "_ma-h";
export var modal = "_ma-0";
export var offerCard = "_ma-c";
export var offerIcon = "_ma-e";
export var sectionLabel = "_ma-9";
export var shell = "_ma-1";
export var title = "_ma-6";